module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av76-d27b7f0c1bd782252ed082b4429d6f4e.jpg";